import React, { Component, Fragment } from 'react'

class Module4 extends Component{
    constructor(props){
        super(props)
        
    }
    render(){
        return(
            <section className="section-wrap page4">
                <div className="block column4">
                    <div className="about">
                        <a href="https://wj.qq.com/s2/8204971/a71a/" target="_blank">申请试用</a>
                        <span>联系顾问</span>
                        <img src="https://www.pzjdimg.com/hitcloud/home/index/phone.png" />
                    </div>
                    {this.props.src && <Fragment>
                            <div className="block-head">
                                {this.props.title}
                            </div>
                            <div className="block-body">
                                <img  src={this.props.src}/>
                            </div>
                        </Fragment>
                    }
                </div>

            </section>
        )
    }
}

export default Module4;
